module.exports = __webpack_public_path__ + "img/career_support_logo.50fc24f8.png";